import { Img, Layout, Rect, type Node } from "@revideo/2d";
import { isRtl, plainTitle, type Clip } from "@hudhud/core";
import { COLORS, HEIGHT, WIDTH } from "@hudhud/reel/math";
import { verticalGradient } from "./gradients";
import { isRtlText, paragraph, runsOf } from "./text";

/** The cover/thumbnail overlay: a dark grade from the bottom, the logo up top and the hook title large across the lower third. */
export function coverOverlay(clip: Clip, logoUrl: string): Node {
  const h = clip.hook;
  const text = plainTitle(h.text) ? h.text : clip.endCard.line;
  const len = plainTitle(text).length;
  const size = Math.round((len > 70 ? 76 : len > 45 ? 92 : 108) * (h.fontSize / 100));
  const rtl = isRtl(clip.captionLang);
  return new Layout({ width: WIDTH, height: HEIGHT, children: [
    new Rect({ width: WIDTH, height: HEIGHT, fill: verticalGradient(HEIGHT, "to top", [{ offset: 0, color: "rgba(11,15,13,0.92)" }, { offset: 0.32, color: "rgba(11,15,13,0.55)" }, { offset: 0.6, color: "rgba(11,15,13,0)" }]) }),
    new Rect({ width: WIDTH, height: HEIGHT, fill: verticalGradient(HEIGHT, "to bottom", [{ offset: 0, color: "rgba(11,15,13,0.45)" }, { offset: 0.22, color: "rgba(11,15,13,0)" }]) }),
    new Img({ src: logoUrl, width: 300, y: 70 - HEIGHT / 2, offset: [0, -1], shadowColor: "rgba(0,0,0,0.6)", shadowBlur: 16, shadowOffset: [0, 6] }),
    paragraph({
      runs: runsOf(text), font: h.font, weight: 900, size, maxWidth: WIDTH - 140, fill: COLORS.offWhite, accentFill: h.accentColor, align: "center",
      lineHeight: rtl ? 1.3 : 1.02, letterSpacing: rtl ? 0 : -size * 0.025, rtl: rtl || isRtlText(text), balance: true,
      line: { shadowColor: "rgba(0,0,0,0.85)", shadowBlur: 40, shadowOffset: [0, 10] },
      block: { offset: [0, 1], y: HEIGHT - 300 - HEIGHT / 2 },
    }),
    new Rect({ width: 120, height: 10, radius: 5, fill: h.accentColor, offset: [0, 1], y: HEIGHT - 250 - HEIGHT / 2 }),
  ] });
}
